module.exports = __webpack_public_path__ + "static/media/yt.75b7ede5.svg";